import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ViewParticipantUrl = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [quizid, setQuizid] = useState("");
  const [user, setUser] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [participantUrl, setParticipantUrl] = useState("");

  useEffect(() => {
    setQuizid(localStorage.getItem("quizid"));
    setUser(localStorage.getItem("user"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);
    try {
      const response = await axiosPrivate.post(
        "/manager/viewurl",
        JSON.stringify({ quizid, user })
      );

      setSuccess(true);
      setParticipantUrl(response?.data?.participantUrl);
      localStorage.setItem("participantUrl", response?.data?.participantUrl);
    } catch (err) {
      console.error(err);
      setErrMsg(err?.response?.data?.message || err?.message);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(participantUrl);
    alert("URL copied to clipboard!");
  };

  return (
    <div className="fade-in" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager/quizdetails")}
      >
        ← Back to Quiz Details
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Participant URL
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          View and copy the unique quiz link for this participant
        </p>
      </div>

      {errMsg && <p className="errmsg">{errMsg}</p>}

      <div className="card" style={{ padding: "2.5rem", textAlign: "center" }}>
        <p style={{ marginBottom: "1.5rem", color: "var(--text-primary)" }}>
          Participant: <span style={{ fontWeight: "600", color: "var(--accent-cyan)" }}>{user}</span>
        </p>

        {!success ? (
          <button className="btn-primary" onClick={handleSubmit}>
            Generate/View URL
          </button>
        ) : (
          <div className="fade-in">
            <div style={{
              background: "rgba(15, 23, 42, 0.5)",
              padding: "1rem",
              borderRadius: "8px",
              border: "1px solid var(--border)",
              marginBottom: "1.5rem",
              wordBreak: "break-all",
              fontFamily: "monospace",
              color: "var(--text-secondary)"
            }}>
              {participantUrl}
            </div>

            <div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
              <button className="btn-primary" onClick={copyToClipboard}>
                📋 Copy URL
              </button>
              <button className="btn-secondary" onClick={() => navigate("/manager/quizdetails")}>
                Done
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewParticipantUrl;
